<template>
  <div class="container">
    <div class="container text m-t-1-sm m-b-3-sm m-y-2-md">
      <h1 class="titulo m-t-2 m-t-3-md">Acceso a la electricidad</h1>
      <hr>

      <p class="texto-primario">Según datos del Censo de Población y Vivienda realizado por el INEGI, en 2020 había en todo el país 265,971 viviendas sin luz eléctrica lo que representa el 0.76% del total de viviendas habitadas en México. En la última década esta cantidad de viviendas sin acceso a la electricidad se ha reducido a la mitad, para el año 2010 había 513 mil 204 viviendas las cuales representaban el 1.79% del total de viviendas habitadas en el país.</p>
      <p class="texto-primario">Sin embargo, a pesar de esta reducción sigue existiendo una importante desigualdad en el acceso eléctrico a escala regional. Los estados de Veracruz (12%), Oaxaca (9.5%), Chihuahua (6.4%) y Guerrero (5.6%) concentran más de un tercio (36%) de las viviendas sin acceso a la electricidad a nivel nacional en 2020, a pesar de que cuentan con la suficiente capacidad de generación eléctrica instalada para satisfacer su demanda interna. También hay algunos municipios, principalmente localizados en la Sierra del Nayar y en la Sierra Tarahumara, donde todavía un 20 o 30% de las viviendas no tienen acceso a la electricidad, así como algunos otros municipios en el país que han incrementado proporcionalmente esta desigualdad durante la última década, como es el caso de 95 municipios donde el porcentaje de viviendas sin luz eléctrica es mayor en 2020 que en 2010, como lo muestra el mapa “Cambios en el acceso a la electricidad entre 2010 y 2020”. </p>

      </div>
      <div>

      <dai-tarjeta-contenedor-mapa :permitir-colapso="true" :es-version-escritorio-en-pantalla-larga="false">
      
        <template v-slot:header>
              <h3>Porcentaje de vivienda sin luz eléctrica por municipio en 2020</h3>

              <dai-leyenda-mapa v-width-control="'70%'"
              titulo="Porcentaje de viviendas"
              :para="['aceso_elect_munip_2020']"
              :tamanosDeMapa="true"
              />

              <dai-interruptor-mapa v-width-control="'30%'"
                v-model="capa_prendida1"
                :opciones="['Mapa','Satélite']"
                /> 
              
        </template>

        
        
        <dai-mapa
        :extension="[-118.365119934082,14.5320978164673,-86.7104034423828,32.7186546325684]" 
        >
            
        <dai-capa-xyz id="Mapa" :visible="capa_prendida1==='Mapa'" url="https://{a-c}.basemaps.cartocdn.com/rastertiles/light_nolabels/{z}/{x}/{y}.png"/>

        <dai-capa-xyz id="Satélite" :visible="capa_prendida1==='Satélite'" url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png"/>

        <dai-capa-topojson  
            id="aceso_elect_munip_2020" 
            url="../geodata/electricidad/aceso_elect_munip_2020.json"
            titulo="Viviendas sin acceso a electricidad por municipio 2020"
            :zoom-al-dar-click="false"
            :contenidoPopup="(feat)=>`<b>Municipio:</b> ${feat.NOM_MUN}, ${feat.NOM_ENT}<br><b>% de viviendas sin luz:</b> ${feat.V_SEP_2020} `"
            :estilo-capa="{
            stroke:{
                color:'#333',                
                width:0.5
              }
            }"
            :reglas-estilo-capa="{
                clasificacion:'personalizada',
                columna : 'V_SEP_2020',
                propiedadObjetivo: 'relleno',
                clases: 6,
                clasificacionPersonalizada: [[0,0],[0,1],[1,5],[5,10],[10,20],[20,30],[30,100]],
                colores: ['#666','#76cb97', '#d3f2b4','#d3f2b4','#f67e4e','#d7191c','#b80404'],

            }"
          />

        </dai-mapa>
          
      </dai-tarjeta-contenedor-mapa>

      <br>

      <dai-tarjeta-contenedor-mapa :permitir-colapso="true" :es-version-escritorio-en-pantalla-larga="false">
      
      <template v-slot:header>
            <h3>Cambios en el porcentaje de viviendas sin luz eléctrica por municipio de 2010 a 2020</h3>

            <dai-leyenda-mapa v-width-control="'70%'"
            titulo="Cambios en el %"
            :para="['aceso_elect_munip_2020']"
            :tamanosDeMapa="true"
            />

            <dai-interruptor-mapa v-width-control="'30%'"
              v-model="capa_prendida2"
              :opciones="['Mapa','Satélite']"
              /> 
            
      </template>

      
      
      <dai-mapa
      :extension="[-118.365119934082,14.5320978164673,-86.7104034423828,32.7186546325684]" 
      >
          
      <dai-capa-xyz id="Mapa" :visible="capa_prendida2==='Mapa'" url="https://{a-c}.basemaps.cartocdn.com/rastertiles/light_nolabels/{z}/{x}/{y}.png"/>

      <dai-capa-xyz id="Satélite" :visible="capa_prendida2==='Satélite'" url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png"/>

      <dai-capa-topojson  
          id="aceso_elect_munip_2020" 
          url="../geodata/electricidad/aceso_elect_munip_2020.json"
          titulo="Viviendas sin acceso a electricidad por municipio 2020"
          :zoom-al-dar-click="false"
          :contenidoPopup="(feat)=>`<b>Municipio:</b> ${feat.NOM_MUN}, ${feat.NOM_ENT}<br><b>Cambios en %:</b> ${feat.D_P_10_20} `"
          :estilo-capa="{
          stroke:{
              color:'#333',                
              width:0.5
            }
          }"
          :reglas-estilo-capa="{
              clasificacion:'personalizada',
              columna : 'D_P_10_20',
              propiedadObjetivo: 'relleno',
              clases: 6,
              clasificacionPersonalizada: [[-20,-1],[-1,0],[0,1],[1,5],[5,10],[10,70]],
              colores: ['#b63d2f', '#cd6c34', '#d6b379', '#abb666', '#789552', '#426d4a'],

          }"
        />

      </dai-mapa>
        
    </dai-tarjeta-contenedor-mapa>
      
      </div>
      <div class="container text m-t-1-sm m-b-3-sm m-y-2-md">

        <p class="texto-primario">Según datos del Censo de Población y Vivienda realizado por el INEGI, en 2020 había 12 mil 593 localidades rurales o urbanas con 5 o más viviendas sin luz eléctrica. Existen 330 localidades donde el número de viviendas sin luz eléctrica es mayor a 50 viviendas.</p>
        <p class="texto-primario">Existe también una gran desigualdad en el acceso a la electricidad dentro de las zonas urbanas. Tijuana (1,352 viviendas), Mexicali (1,323), Cancún (1,017, Matamoros (958) y Hermosillo (804), son las ciudades con mayor número de viviendas sin luz eléctrica a pesar de tener demandas eléctricas muy elevadas (Mexicali, según datos de la CFE,  era el municipio con mayor demanda eléctrica total en 2018, y Tijuana el cuarto). Eso muestra el acceso desigual a la electricidad existente dentro de un mismo municipio, relacionada con la segregación socio espacial existentes en las urbes. </p>

      </div>
      <div>

        <dai-tarjeta-contenedor-mapa :permitir-colapso="true" :es-version-escritorio-en-pantalla-larga="false">
      
          <template v-slot:header>
                <h3>Mapa de localidades con más de 5 viviendas sin luz eléctrica</h3>

                <p class="texto-principal" v-width-control="'100%'">Datos para 2020.</p>

                <dai-leyenda-mapa v-width-control="'70%'"
                titulo="Localidades con viviendas sin acceso a la electricidad"
                :para="['loc_5_vivienda_sin_elect_2020']"
                :tamanosDeMapa="true"
                />

                <dai-interruptor-mapa v-width-control="'30%'"
                  v-model="capa_prendida3"
                  :opciones="['Mapa','Satélite']"
                  /> 
                
          </template>

          
          
          <dai-mapa
          :extension="[-118.365119934082,14.5320978164673,-86.7104034423828,32.7186546325684]" 
          >
              
          <dai-capa-xyz id="Mapa" :visible="capa_prendida3==='Mapa'" url="https://{a-c}.basemaps.cartocdn.com/rastertiles/light_nolabels/{z}/{x}/{y}.png"/>

          <dai-capa-xyz id="Satélite" :visible="capa_prendida3==='Satélite'" url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png"/>

          <dai-capa-topojson  
              id="loc_5_vivienda_sin_elect_2020" 
              url="../geodata/electricidad/loc_5_vivienda_sin_elect_2020.json"
              titulo="Viviendas sin acceso a electricidad por municipio 2020"
              :zoom-al-dar-click="false"
              :contenidoPopup="(feat)=>`<b>Municipio:</b> ${feat.NOM_MUN}, ${feat.NOM_ENT}<br><b>Viviendas sin electricidad:</b> ${feat.VPH_S_ELEC} `"
              :estilo-capa="{
                circle:{
                    fill:{color:'#333'},
                    stroke:{color:'#FFF',width:1},
                    radius:2
                  }
                }"
              :reglas-estilo-capa="[{
                  clasificacion:'personalizada',
                  columna : 'VPH_S_ELEC',
                  propiedadObjetivo: 'relleno',
                  clases: 4,
                  clasificacionPersonalizada: [[100,1000],[50,100],[25,50],[5,25]],
                  colores: ['#7f0f07', '#d23d0b', '#fe8708', '#eccf26'],

              }]"
            />

          </dai-mapa>
            
        </dai-tarjeta-contenedor-mapa>

        <br>

        <dai-tarjeta-contenedor-mapa :permitir-colapso="true" :es-version-escritorio-en-pantalla-larga="false">
      
      <template v-slot:header>
            <h3>Mapa de localidades con más de 5 viviendas sin luz eléctrica  (% del total de viviendas en la localidad)</h3>

            <p class="texto-principal" v-width-control="'100%'">Datos para 2020.</p>

            <dai-leyenda-mapa v-width-control="'70%'"
            titulo="Porcentaje de viviendas sin acceso a la electricidad por localidad"
            :para="['loc_5_vivienda_sin_elect_2020']"
            :tamanosDeMapa="true"
            />

            <dai-interruptor-mapa v-width-control="'30%'"
              v-model="capa_prendida4"
              :opciones="['Mapa','Satélite']"
              /> 
            
      </template>

      
      
      <dai-mapa
      :extension="[-118.365119934082,14.5320978164673,-86.7104034423828,32.7186546325684]" 
      >
          
      <dai-capa-xyz id="Mapa" :visible="capa_prendida4==='Mapa'" url="https://{a-c}.basemaps.cartocdn.com/rastertiles/light_nolabels/{z}/{x}/{y}.png"/>

      <dai-capa-xyz id="Satélite" :visible="capa_prendida4==='Satélite'" url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png"/>

      <dai-capa-topojson  
          id="loc_5_vivienda_sin_elect_2020" 
          url="../geodata/electricidad/loc_5_vivienda_sin_elect_2020.json"
          titulo="Viviendas sin acceso a electricidad por municipio 2020"
          :zoom-al-dar-click="false"
          :contenidoPopup="(feat)=>`<b>Municipio:</b> ${feat.NOM_MUN}, ${feat.NOM_ENT}<br><b>Porcentaje de viviendas sin electricidad:</b> ${feat.PER_VPH_SE}% `"
          :estilo-capa="{
            circle:{
                fill:{color:'#333'},
                stroke:{color:'#FFF',width:1},
                radius:2
              }
            }"
          :reglas-estilo-capa="[{
              clasificacion:'personalizada',
              columna : 'PER_VPH_SE',
              propiedadObjetivo: 'relleno',
              clases: 4,
              clasificacionPersonalizada: [[100,100],[50,100],[25,50],[10,25],[0,10]],
              colores: ['#2a0101', '#7f0f07', '#d23d0b', '#fe8708', '#eccf26'],

          }]"
        />

      </dai-mapa>
        
    </dai-tarjeta-contenedor-mapa>


      </div>

      <div class="contenedor-referencias-bibliograficas container text m-t-1-sm m-b-3-sm m-y-2-md">
          <div class="encabezado"><h2>Referencias bibliográficas</h2></div>
          <ul class="lista-referencias">
            <li><em><strong>GeoComunes (2020).</strong></em> Vivienda sin luz eléctrica por municipio en 2020. Recuperado en diciembre del 2022. <a href="http://geocomunes.org/Visualizadores/SistemaElectricoMexico/" target="_blank">http://geocomunes.org/Visualizadores/SistemaElectricoMexico/</a></li>
            <li><em><strong>GeoComunes (2020).</strong></em> Vivienda sin luz eléctrica por localidades en 2020. Recuperado en diciembre del 2022. <a href="http://geocomunes.org/Visualizadores/SistemaElectricoMexico/" target="_blank">http://geocomunes.org/Visualizadores/SistemaElectricoMexico/</a></li>
            <li><em><strong>Instituto Nacional de Estadística y Geografía (2020).</strong></em> Censo de Población y Vivienda 2020. Recuperado en octubre del 2020. <a href="https://www.inegi.org.mx/programas/ccpv/2020/" target="_blank">https://www.inegi.org.mx/programas/ccpv/2020/</a></li>
            <li><em><strong>Instituto Nacional de Estadística y Geografía (2010).</strong></em> Censo de Población y Vivienda 2010. Recuperado en octubre del 2020. <a href="https://www.inegi.org.mx/programas/ccpv/2010/" target="_blank">https://www.inegi.org.mx/programas/ccpv/2010/</a></li>

          </ul>
      </div>

  </div>
</template>
<script>
  
  import * as am4core from "@amcharts/amcharts4/core";
  import * as am4charts from "@amcharts/amcharts4/charts";
  

  import am4themes_kelly from "@amcharts/amcharts4/themes/kelly";

  am4core.useTheme(am4themes_kelly);
  

  export default {
    name: 'App',
    components: {
      
    },
    data: function () {
      return {
        capa_prendida1: 'Mapa',
        capa_prendida2: 'Mapa',
        capa_prendida3: 'Mapa',
        capa_prendida4: 'Mapa',
      }   
    },
    mounted() {

      
      

      

    },
    beforeDestroy() {
     
    },
  }

</script>
<style scoped lang="scss">


</style>
